import { createFileRoute } from '@tanstack/react-router'
import UpcomingSettlementsReportList from 'Royalty/components/Test/tabs/UpcomingSettlementsReportList'

export const Route = createFileRoute('/royalty/reports/upcoming-settlements')({
    component: UpcomingSettlementsReportList,
})
